export const visit = (url: string) => {
  if (window.Turbolinks?.visit) {
    window.Turbolinks.visit(url);
    return;
  }

  // recovery if nothing turbolinks
  window.location.href = url;
};
